export default __webpack_public_path__ + "static/media/popup_m.c855f032.jpg";